import get from "lodash/get";
import axiosClient from "./axiosClient";
import { apiPath } from "../../utils/api-contants";
import { FactoryDataRequestPayloadTypes } from "../models/factory-management";

const FactoryManagementService = {
  fetchFactoriesList: async (payload: FactoryDataRequestPayloadTypes) => {
    try {
      const apiResponse: any = await axiosClient.get(
        apiPath.SITE_FACTORY_MANAGEMENT_URL,
        { params: payload },
      );
      const res: any = get(apiResponse, "data", []);

      return {
        status: "success",
        code: res.status,
        res: res,
      };
    } catch (error: any) {
      return {
        status: "error",
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  fetchFactory: async (factoryId: string) => {
    try {
      const apiResponse: any = await axiosClient.get(
        `${apiPath.SITE_FACTORY_MANAGEMENT_URL}/${factoryId}`,
      );
      const res: any = apiResponse.data;

      return {
        status: "success",
        code: 200,
        res,
      };
    } catch (error: any) {
      return {
        status: "error",
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  addFactory: async (payload: any) => {
    try {
      const apiResponse = await axiosClient.post(
        apiPath.SITE_FACTORY_MANAGEMENT_URL,
        payload,
      );
      return {
        status: "success",
        code: apiResponse.status,
        res: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: "error",
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  updateFactory: async (payload: any) => {
    try {
      const apiResponse = await axiosClient.patch(
        `${apiPath.SITE_FACTORY_MANAGEMENT_URL}/${payload.factory_id}`,
        payload,
      );
      return {
        status: "success",
        code: apiResponse.status,
        res: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: "error",
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  updateFactoryStatus: async (payload: any) => {
    try {
      const apiResponse = await axiosClient.patch(
        `${apiPath.SITE_FACTORY_MANAGEMENT_URL}`,
        payload,
      );
      return {
        status: "success",
        code: apiResponse.status,
        res: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: "error",
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  removeFactory: async (factoryId: any) => {
    try {
      const apiResponse = await axiosClient.delete(
        `${apiPath.SITE_FACTORY_MANAGEMENT_URL}/${factoryId}`,
      );
      return {
        status: "success",
        code: apiResponse.status,
        res: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: "error",
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  fetchAssetComponents: async (assetId: string) => {
    try {
      const apiResponse: any = await axiosClient.get(
        `${apiPath.SITE_FACTORY_MANAGEMENT_URL}/components/${assetId}`,
      );
      const res: any = apiResponse.data;

      return {
        status: "success",
        code: 200,
        res,
      };
    } catch (error: any) {
      return {
        status: "error",
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  scanTagsApiCall: async (payload: any) => {
    try {
      const apiResponse = await axiosClient.post(
        `${apiPath.SITE_FACTORY_MANAGEMENT_URL}/scan_tags`,
        payload,
      );
      const res: any = apiResponse.data;

      return {
        status: "success",
        code: 200,
        res,
      };
    } catch (error: any) {
      return {
        status: "error",
        code: error?.response?.status,
        // data: error?.response,
        data: payload?.message?.command_id || "",
      };
    }
  },
  fetchCopyConfigurationFromList: async (payload: any) => {
    try {
      const apiResponse: any = await axiosClient.get(
        `${apiPath.SITE_FACTORY_MANAGEMENT_URL}/factory_assets/${payload.factory_id}?asset_id=${payload.asset_id}&component_id=${payload.component_id}`,
      );
      const res: any = get(apiResponse, "data", {});
      return {
        status: "success",
        code: apiResponse.status,
        res: res,
      };
    } catch (error: any) {
      return {
        status: "error",
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  fetchCopyConfigurationFromComponent: async (payload: any) => {
    try {
      const apiResponse: any = await axiosClient.get(
        `${apiPath.SITE_FACTORY_MANAGEMENT_URL}/components/${payload.asset_id}?component_id=${payload.component_id}`,
      );
      const res: any = get(apiResponse, "data", {});
      return {
        status: "success",
        code: apiResponse.status,
        res: res,
      };
    } catch (error: any) {
      return {
        status: "error",
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  fetchAssetsConfig: async (payload: any) => {
    try {
      const apiResponse = await axiosClient.post(
        `${apiPath.SITE_FACTORY_MANAGEMENT_URL}/asset_components`,
        payload,
      );
      return {
        status: "success",
        code: apiResponse.status,
        res: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: "error",
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
};

export default FactoryManagementService;
